import { render, staticRenderFns } from "./DashboardQuickAccessCard.vue?vue&type=template&id=7c92bec4&scoped=true&"
import script from "./DashboardQuickAccessCard.vue?vue&type=script&lang=js&"
export * from "./DashboardQuickAccessCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardQuickAccessCard.vue?vue&type=style&index=0&id=7c92bec4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c92bec4",
  null
  
)

export default component.exports